<script>
import NoOrders from "./NoOrders";

import dateMixin from "@/mixins/dateMixin.js";
import addressMixin from "@/mixins/addressMixin.js";
import timeMixin from "@/mixins/timeMixin.js";
import numberMixin from "@/mixins/numberMixin.js";
import orderMixin from "@/mixins/orderMixin.js";

import { mapState, mapActions } from "vuex";
import { unique } from "@/utils/arrays";

export default {
  mixins: [addressMixin, dateMixin, timeMixin, numberMixin, orderMixin],

  components: {
    NoOrders
  },

  computed: {
    ...mapState("orders", ["list", "preloader", "pagination", "sort", "type"])
  },

  data() {
    return {
      orders: []
    };
  },

  methods: {
    ...mapActions("orders", [
      "listAll",
      "setCurrentPage",
      "setSort",
      "setType"
    ]),

    getOrders() {
      this.orders = this.orders.concat(this.list);
      this.orders = unique(this.orders, e => e.id);
    }
  },

  watch: {
    list() {
      this.getOrders();
    }
  },

  mounted() {
    this.listAll();
  }
};
</script>

<template>
  <section>
    <no-orders v-if="!orders.length && !preloader" />

    <div v-else class="section">
      <div class="row">
        <div class="title">histórico de limpezas</div>

        <div class="buttons-filters">
          <router-link :to="{name: 'purchase-flow'}" class="btn bg-pink">fazer novo pedido</router-link>
        </div>
      </div>

      <div class="orders">
        <div v-for="(order, index) in orders" :key="index" class="card">
          <div class="professional-image">
            <img
              :src="order.professional.account.profile.profile_picture"
              :alt="order.professional.account.first_name"
            />
          </div>
          <div class="order-informations">
            <div
              class="name"
            >{{order.professional.account.first_name}} {{order.professional.account.last_name}}</div>

            <div class="status">
              <img class="status-image" :src="order.status | getIcon" />
              {{order.status | getTranslatedName}}
            </div>

            <p>dia {{order.schedule_event.starts_at | formatDate('DD/MM/Y [às] H[h]')}} com duração de {{order.schedule_event.duration | secToHours(true)}}</p>
          </div>

          <router-link
            :to="'pedidos/'+order.id"
            class="btn bg-purple-outline btn-small mt-10"
          >ver mais</router-link>
        </div>
      </div>

      <div
        v-if="pagination.current < pagination.totalPages"
        @click="setCurrentPage(pagination.current + 1)"
        class="btn bg-purple mt-20"
        :class="{'btn--loading': preloader}"
      >
        <span>carregar mais</span>
      </div>

      <div
        v-if="pagination.current >= pagination.totalPages && preloader"
        class="btn bg-purple btn--loading mt-20"
      ></div>
    </div>
  </section>
</template>

<style scoped>
.btn {
  margin: 0;
}

.card {
  margin: 0;
}

.row {
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.type {
  text-align: center;
  font-size: 13px;
  margin: 5px 0;
}

.orders {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 10px;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.24s ease;
  cursor: pointer;
}

.card:hover {
  transform: scale(1.01);
}

.professional-image {
  min-width: 80px;
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.professional-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 100%;
  border: 3px solid var(--gray);
}

.order-informations {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
}

.order-informations p {
  margin-bottom: 0;
  margin-top: 5px;
  text-align: center;
}

.name {
  font-size: 18px;
  font-weight: 500;
  color: var(--purple);
  text-align: center;
}

.status {
  margin-top: 5px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.status-image {
  height: 12px;
  margin-right: 3px;
}

@media (max-width: 480px) {
  .title {
    margin-top: 10px;
  }
  .row {
    flex-direction: column !important;
  }
  .orders {
    grid-template-columns: 1fr;
  }
  .professional-image {
    min-width: 60px;
    width: 60px;
    height: 60px;
  }

  .name {
    font-size: 14px;
  }

  .card {
    padding: 10px 20px;
  }

  .order-informations {
    font-size: 12px;
  }

  .status-image {
    height: 15px;
    margin-right: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderHistory/Mobile.vue